import { MapPinOff } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Says how many events a location filter could not measure.
 *
 * "No location on file" and "too far away" look identical in a filtered list,
 * and only one of them is the reader's own doing. Without this, a zip search
 * makes the calendar look emptier than it is and there is nothing on screen to
 * explain why.
 */
export function UnplaceableNote({
  count,
  className,
}: {
  count: number;
  className?: string;
}) {
  if (count <= 0) return null;
  const plural = count !== 1;
  return (
    <p
      className={cn(
        "flex items-start gap-2 text-xs text-muted-foreground",
        className
      )}
    >
      <MapPinOff className="w-3.5 h-3.5 mt-0.5 flex-shrink-0" />
      {count} event{plural ? "s" : ""} hidden — no location on file yet, so{" "}
      {plural ? "they" : "it"} can't be measured from here.
    </p>
  );
}
